// removed by extract-text-webpack-plugin
module.exports = {"container":"_79_cm80Vj8vNsm-wBcq5","IconTrailing":"_2mQBQe0YYoHcnuc6AIGU3U","Title":"_3bdrUTCqk7r4w6eUQyu7a_","Name":"xN7eMN6myo81miY6d2yJw","Button":"fT1kcW4JecDfCiPeTQkcu"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/DocumentVerify/Main/Verify/Title/styles.css
// module id = 3001
// module chunks = 0